import { LanguageSwitcher } from '@components/shared/LanguageSwitcher';
import { AuthHeader } from '@features/auth/AuthHeader';
import { usePathMatchIndex } from '@features/auth/hooks';
import { AuthStepper } from '@features/auth/registration/components/Common/AuthStepper';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { usePageTitle } from '@hooks/usePageTitle';
import { useTranslation } from 'react-i18next';
import { StepNames } from '../registration.types';

const steps = ['personalDetails', 'resume'];

export function CompanyRegistrationLayout() {
	const activeStepIndex = usePathMatchIndex(steps);
	const { t } = useTranslation();
	const { navigateWithLanguage } = useLanguageNavigate();

	usePageTitle(`${t('singUp')} - ${t('company')}`);

	return (
		<>
			<div className="flex items-center justify-end absolute top-[20px] right-0 z-20">
				<LanguageSwitcher />
			</div>
			<AuthStepper
				header={
					<AuthHeader
						title={t('singUp')}
						spacing="mt-[50px] max-sm:mt-[30px]"
						wrapperSpacing="mb-[36px] max-sm:mb-[29px]"
					/>
				}
				showBackButton={!!activeStepIndex}
				onBackButtonClick={() => {
					navigateWithLanguage('/company/personal-details', {
						state: { step: StepNames.PERSONAL_DETAILS },
					});
				}}
				activeStepIndex={activeStepIndex}
				steps={steps}
			/>
		</>
	);
}
